/* WorkTriggerGeneralTabComponent.js */

"use strict";
const Renderer = require("./WorkTriggerGeneralTabRenderer");

class WorkTriggerGeneralTabComponent {
    constructor(workTriggerDetailsView) {
        this._renderer = new Renderer(workTriggerDetailsView);
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        return Promise.resolve();
    }
}
module.exports = WorkTriggerGeneralTabComponent;
